import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApButtonComponent } from '@ap/button';
import { ApContentModule } from '@ap/content';
import { ApInlineSvgDirective } from '@ap/inline-svg';

import { FeedbackModalModule } from './feedback/modal/modal.module';
import { MijnFeedbackComponent } from './mijn-feedback.component';

/**
 * @ngdoc module
 * @name MijnFeedbackModule
 */
@NgModule({
    imports: [ApContentModule, CommonModule, FeedbackModalModule, ApButtonComponent, ApInlineSvgDirective],
    exports: [MijnFeedbackComponent],
    declarations: [MijnFeedbackComponent]
})
export class MijnFeedbackModule {}
